/**
 * Sesión de soporte: alguien de Soporte Técnico entró a la cuenta de un usuario desde el panel
 * administrativo ("Entrar como este usuario"), sin ver ni cambiar su contraseña.
 *
 * El panel genera un permiso de un solo uso (un token de Firebase Auth con `soporte: true`) y se lo
 * pasa a esta app de ventana a ventana con postMessage, nunca por la URL (ver
 * src/views/Soporte/EntrarComoUsuario.vue). La sesión queda solo en esa pestaña (persistencia de
 * sesión del navegador) y la marca de abajo vive en sessionStorage, con la misma vida: así el
 * arranque de la app sabe sin esperar el token que en esa pestaña no debe rastrear actividad ni
 * ubicación, ni registrar notificaciones push, ni aceptar términos a nombre del usuario.
 */
const CLAVE = "riskmann-sesion-soporte";

/** Tipos de mensaje entre el panel administrativo y esta app. */
export const TIPO_SOPORTE_LISTO = "riskmann:soporte:listo";
export const TIPO_SOPORTE_TOKEN = "riskmann:soporte:token";

/** La sesión de soporte se cierra sola pasado este tiempo desde que se entró. */
export const DURACION_MAXIMA_SOPORTE_MS = 2 * 60 * 60 * 1000;

/**
 * Orígenes del panel administrativo que pueden abrir una sesión de soporte. En desarrollo se suma
 * el que diga VUE_APP_ORIGENES_PANEL_ADMIN (separados por coma), p. ej. el panel corriendo en local.
 */
export const ORIGENES_PANEL_ADMIN = [
  "https://riskmann-admin.web.app",
  "https://riskmann-admin.firebaseapp.com",
].concat(
  process.env.NODE_ENV === "development" && process.env.VUE_APP_ORIGENES_PANEL_ADMIN
    ? process.env.VUE_APP_ORIGENES_PANEL_ADMIN.split(",").map((origen) => origen.trim()).filter(Boolean)
    : [],
);

export function esSesionSoporte() {
  try {
    return window.sessionStorage.getItem(CLAVE) === "1";
  } catch (error) {
    return false;
  }
}

export function marcarSesionSoporte() {
  try {
    window.sessionStorage.setItem(CLAVE, "1");
  } catch (error) {
    // Sin sessionStorage la sesión igual funciona; la franja la detecta por el token.
  }
}

export function desmarcarSesionSoporte() {
  try {
    window.sessionStorage.removeItem(CLAVE);
  } catch (error) {
    // Nada que limpiar.
  }
}
